import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Resolve, Router} from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class UserResolver implements Resolve<any> {
  constructor(private service: AuthService, private router: Router) {}

  resolve(): Observable<any>|Promise<any>|any {
    return this.service.ensureLoggedIn().catch((err: any) => {
      // We may want to introduce Unauthorized Page
        this.router.navigate(['/home']);
    });
    }
}
